/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetSummaryLookupResponseDto
 */
export interface AssetSummaryLookupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSummaryLookupResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSummaryLookupResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetSummaryLookupResponseDto interface.
 */
export function instanceOfAssetSummaryLookupResponseDto(value: object): value is AssetSummaryLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetSummaryLookupResponseDtoFromJSON(json: any): AssetSummaryLookupResponseDto {
    return AssetSummaryLookupResponseDtoFromJSONTyped(json, false);
}

export function AssetSummaryLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSummaryLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetSummaryLookupResponseDtoToJSON(json: any): AssetSummaryLookupResponseDto {
    return AssetSummaryLookupResponseDtoToJSONTyped(json, false);
}

export function AssetSummaryLookupResponseDtoToJSONTyped(value?: AssetSummaryLookupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

